import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
// config
import { HEADER, NAV } from '../../config-global';
//
import MarketingAssetsHeader from './MarketingAssetsHeader';
import MarketingAssetsNavVertical from './MarketingAssetsNavVertical';

// ----------------------------------------------------------------------

const SPACING = 8;

// Vertical only on purpose: this layout never reads themeLayout, so a visitor
// carrying `mini` or `horizontal` in localStorage still gets a matching
// 400px nav and main width.
export default function MarketingAssetsLayout() {
  const isDesktop = useResponsive('up', 'lg');

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <MarketingAssetsHeader onOpenNav={handleOpen} />

      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: { lg: 1 },
        }}
      >
        <MarketingAssetsNavVertical openNav={open} onCloseNav={handleClose} />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            py: `${HEADER.H_MOBILE + SPACING}px`,
            ...(isDesktop && {
              px: 2,
              py: `${HEADER.H_DASHBOARD_DESKTOP + SPACING}px`,
              width: `calc(100% - ${NAV.W_DASHBOARD}px)`,
            }),
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </>
  );
}
